export default "__VITE_ASSET__Cee$uq79__"